
import Applications from '@/graphql/queries/taxonomies/Applications'

export default {
  vessel: {
    title: {
      fontSize: '2xl',
      marginBottom: 'sm'
    },
    subtitle: {
      fontSize: 'xl',
      fontWeight: 'normal',
      marginBottom: 'sm'
    }
  },
  data() {
    return {
      section: null,
      items: []
    }
  },
  async fetch() {
    const { $graphql, $content, $i18n: { locale } } = this
    this.section = await $content(locale, 'sections/applications').fetch()

    const { data } = await $graphql.query({
      path: 'queries/taxonomies',
      clientId: 'eshop',
      query: Applications
    })

    this.items = data
  }
}
